<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>{{ title }}</h2>
      <i
        v-if="isEmpty(linkedaccountDetail)"
        @click="Refresh"
        class="bx bx-refresh w3-hover-text-red size32 w3-right p-2 cursor"
        title="Refresh data"
      ></i>
    </header>

    <div class="p-0 p-md-4">
      <div v-if="!isEmpty(linkedaccountDetail)">
        <LinkedAccountDetail
          :fundcode="FundCode"
          :linkedaccount="linkedaccountDetail"
          @close="CloseDetail"
        />
      </div>
      <div v-else class="row w3-animate-top">
        <div class="col-12 col-xl-10">
          <template v-if="fetching">
            <div class="loading_spinner_box">
              <div class="loading_spinner"></div>
            </div>
          </template>
          <template v-else>
            <template v-if="!isEmpty(LinkedAccounts)">
              <template v-for="(Accounts, fund) in LinkedAccounts" :key="fund">
                <template v-if="Accounts && !isEmpty(Accounts)">
                  <h4 class="bold w3-text-red">{{ fund }}</h4>
                  <div class="row equalHeightColumns">
                    <div
                      v-for="linkedAccount in Accounts"
                      :key="linkedAccount.SubContactNo"
                      class="col-md-6"
                    >
                      <LinkedAccountCard
                        :fundcode="fund"
                        :linkedaccount="linkedAccount"
                        @mounted="make_equal_height_columns"
                        @show_detail="ShowDetail"
                      />
                    </div>
                  </div>
                </template>
              </template>
            </template>

            <div v-else class="row">
              <div class="col-md-6">
                <SubAccountCardEmpty />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from "vuex";
import { ref, computed, onBeforeMount, watchEffect } from "vue";
import { equalHeightColumns, isEmpty } from "@/helpers/utilities";
import LinkedAccountCard from "@/components/LinkedAccountCard.vue";
import SubAccountCardEmpty from "@/components/SubAccountCardEmpty";
import LinkedAccountDetail from "@/components/LinkedAccountDetail";

export default {
  components: { LinkedAccountCard, SubAccountCardEmpty, LinkedAccountDetail },
  setup() {
    const title = ref("Linked Accounts");
    const store = useStore();

    const LinkedAccounts = ref({});
    const FundCode = ref("");
    const fetching = ref(false);
    const LinkedAccountsData = computed(
      () => store.getters["getLinkedAccounts"]
    );
    const LinkedAccountsFetchingData = computed(
      () => store.getters["getLinkedAccountsFetching"]
    );
    const linkedaccountDetail = ref({});
    const Refresh = () => {
      store.dispatch("GetAllLinkedAccounts");
    };
    const ShowDetail = (fundcode, linkedaccount) => {
      FundCode.value = fundcode;
      linkedaccountDetail.value = linkedaccount;
      title.value = "Linked Account Detail";
    };
    const CloseDetail = () => {
      FundCode.value = "";
      linkedaccountDetail.value = {};
      title.value = "Linked Accounts";
    };
    watchEffect(() => {
      LinkedAccounts.value = LinkedAccountsData.value;
      fetching.value = LinkedAccountsFetchingData.value;
    });
    if (isEmpty(LinkedAccounts.value)) {
      Refresh();
    }
    const make_equal_height_columns = () => {
      equalHeightColumns();
    };
    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    return {
      title,
      fetching,
      FundCode,
      LinkedAccounts,
      linkedaccountDetail,
      make_equal_height_columns,
      isEmpty,
      Refresh,
      ShowDetail,
      CloseDetail,
    };
  },
};
</script>